import React from 'react';

const NotFound = () => {
    return (
        <div className="App">
            <img src="https://image.freepik.com/free-vector/404-error-with-character-error-design-template-website_114341-24.jpg" alt="" />
        </div>
    );
};

export default NotFound;